import {
  Spinner,
  GreyGrey60,
  Primary13Regular,
  Flex
} from '@sequencehq/core-components'

export const NavLinksLoading = () => (
  <Flex
    alignItems="center"
    height="32px"
    padding="0 8px"
    gap="8px"
    {...Primary13Regular}
    color={GreyGrey60}
  >
    <Spinner height="16px" width="16px" color={GreyGrey60} /> Loading...
  </Flex>
)
